import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, Ref } from '@eastsideco/salvo-ts';
import { SideCart } from '../SideCart/SideCart';
import { debounce } from 'lodash';
import { cart } from '@/theme/Cart';

@Component
export class CartMainSummary extends ThemeComponent {

    @Ref({ required: false }) continueShoppingButton!: HTMLButtonElement;
    @Ref({required: false}) orderNote!: HTMLTextAreaElement;

    init() {

        // Listen for continue shopping click
        this.listenForContinueShoppingClick();

        // Listen for order note change
        this.listenForOrderNoteChange();
    }

    listenForContinueShoppingClick() {
        if (this.continueShoppingButton == null) {
            return;
        }
        this.$listen(this.continueShoppingButton, 'click', () => {

            // Attempt to find side cart
            const sideCart = this.closest('.side-cart');
            if (sideCart) {
                const sideCartComponent = sideCart as SideCart;

                // Close side cart
                sideCartComponent.close();
            }
        });
    }

    listenForOrderNoteChange() {

        // Ensure order note element exists
        if (!this.orderNote) {
            return;
        }

        // Listen for order note change
        this.$listen(this.orderNote, 'input', debounce(async() => {

            // Get order note value
            const orderNote = this.orderNote.value.trim();

            // Update cart attribute
            const attributes = {
                ['note']: orderNote
            };
            await cart.updateAttributes(attributes);
        }, 500));
    }
}
